import React, { useState } from "react";
import { sendEmailToTeacher } from "../../../../../store/actions/payout";
import styles from "../styles.module.css";
import { toast } from "react-toastify";

const SendMailModal = ({ data, setSendMailModal }) => {


  const [formData, setFormData] = useState({
    subject: "",
    body: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    await sendEmailToTeacher({
      fullName: "",
      email: data?.teacherId?.userId?.email,
      data: formData.body,
      subject: formData.subject,
    });

    toast.success("Mail sent ");
    setSendMailModal(false);
  };

  return (
    <div className={styles.modalBackdrop}>
      <div
        className={styles.modal}
        style={{ width: "500px" }}>
        <div className={styles.modal_header}>
          <h1>Send Email</h1>

          <i
            className={styles.closeBtn + " fas fa-close"}
            onClick={() => {
              setSendMailModal(false);
            }}></i>
        </div>
        <div className={styles.modal_body}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginTop: "1rem" }}>
              <div className={styles.inputFormat} style={{ marginBottom: "1rem", opacity: 0.7 }}>
                <input
                  type='text'
                  value={data?.teacherId?.userId?.email}
                  disabled
                />
              </div>

              <div className={styles.inputFormat} style={{ marginBottom: "1rem" }}>
                <input
                  type='text'
                  placeholder='Subject'
                  value={formData.subject}
                  required
                  onChange={(e) => {
                    setFormData({ ...formData, subject: e.target.value });
                  }}
                />
              </div>

              <div className={styles.inputFormat}>
                <textarea
                  placeholder='Write your message here...'
                  value={formData.body}
                  required
                  style={{
                    width: "100%",
                    minHeight: "150px",
                    borderRadius: "12px",
                    border: "2px solid #e2e8f0",
                    padding: "12px 16px",
                    fontSize: "1rem",
                    transition: "all 0.2s",
                    fontFamily: "inherit"
                  }}
                  onChange={(e) => {
                    setFormData({ ...formData, body: e.target.value });
                  }}
                />
              </div>
            </div>

            <div style={{ marginTop: "2rem" }}>
              <button
                type='submit'
                className={styles.submitBtn}>
                Send Email
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SendMailModal;
